import ErrorMessage from '../ErrorMessage';

export default class NoMediaDeviceError extends Error {
  name = ErrorMessage.NO_MEDIA_DEVICE;
}
